import React, { Component } from 'react'
import { AppProperties, AppSetting, Logout } from '../../common/functions';
import axios from 'axios'
import ApiRequestService from '../../components/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import { Typography } from '@mui/material';
import LoadingSpinner from '../../components/LoadingSpinner';

class SFAnonymousPage extends Component {

  appProperties = AppProperties();
  appSetting = AppSetting();

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      isValid: true,
    }
  }

  componentDidMount() {
    document.title = 'Anonymous Assignment | STEM Fluency';

    const queryParams = new URLSearchParams(window.location.search);
    let code = queryParams.get('code')

    if (code && code !== '') {

      // Based on the code get the student quiz URL for anonymous survey
      console.debug('code>>>', code);

      // Send the code and ip
      let payload = {
        code,
      }

      this.getAnonymousLink(payload);

    } else {
      console.warn('No code provided');
      this.setState({
        isValid: false,
        loading: false,
      })
    }
  }


  getAnonymousLink(payload) {
    let responsePromise = ApiRequestService({
      method: "POST",
      url: "/getAnonymousAssignmentURLByCode",
      data: payload
    });

    responsePromise.then(res => {
      console.debug("res.data.data", res.data.data)
      if (res && res.data && res.data.data) {
        const queryParams = new URLSearchParams(res.data.data);
        let token = queryParams.get('token')
        console.debug("token>>??",token)
        if (token) {
          const [encodedHeader, encodedPayload, signature] = token.split('.');
          let decodedPayload;
          try {
            decodedPayload = JSON.parse(atob(encodedPayload));
          } catch (error) {
            console.error("Unable to decode the token", token, error)
            NotificationManager.error(`Unable to decode the token: ${token}`, "ERROR", 3000)
            return;
          }

          console.debug("decodedPayload>>>", decodedPayload)

          if (decodedPayload) {
            Logout();
            window.localStorage.setItem("isLTIStudent", decodedPayload.isLTIStudent);
            this.appProperties.currentUserData.setUserDetails(decodedPayload, this.appProperties.loginType);
          }

          // Remove the token once it's been used
          if (queryParams.has('token')) {
            const url = new URL(res.data.data);
            url.searchParams.delete('token');
            const cleanUrl = url.origin + url.pathname + (url.search ? `?${url.searchParams.toString()}` : '');
            console.debug("cleanUrl", cleanUrl)
            window.history.replaceState(null, '', cleanUrl);
            window.location.reload();
          }
        }

      } else {
        NotificationManager.error("Either code is invalid or quiz is closed.", "ERROR", 3000)
        this.setState({
          isValid: false,
        })
      }
    }).finally(() => {
      this.setState({
        loading: false,
      })
    })
  }

  render() {
    return (
      <div className='sf-fixed-center'>
        {!this.state.isValid ?
          <div className='text-center'>
            <Typography variant='h6'>Either your link is broken or the quiz is closed</Typography>
            {/* <Link to="/">
              <Button className='mt-3' variant='contained'>Go To Login</Button>
            </Link> */}
          </div>
          : null}
        <LoadingSpinner loading={this.state.loading} />
      </div>
    );
  }
}

export default SFAnonymousPage;
